import { render, staticRenderFns } from "./ProfileCreator.vue?vue&type=template&id=e123f484&scoped=true&"
import script from "./ProfileCreator.vue?vue&type=script&lang=js&"
export * from "./ProfileCreator.vue?vue&type=script&lang=js&"
import style0 from "./ProfileCreator.vue?vue&type=style&index=0&id=e123f484&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e123f484",
  null
  
)

export default component.exports